"use client";

import React, { useEffect, useRef } from "react";
import Image from "next/image";

export default function MobileVideoStrip() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const hasPlayedRef = useRef(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasPlayedRef.current) {
          hasPlayedRef.current = true;
          video.play();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  const appStoreLinks = [
    {
      name: "App Store",
      href: "https://itunes.apple.com/us/app/mysiponline/id1246082058?ls=1&mt=8",
      image: "app-store",
    },
    {
      name: "Google Play",
      href: "https://play.google.com/store/apps/details?id=com.mysiponline",
      image: "play-store",
    },
  ];

  return (
    <section className="w-full text-white xs:px-4 pt-16 xs:pt-0 bg-[linear-gradient(180deg,#000000_42%,#001843_100%)] xs:bg-[linear-gradient(180deg,#000000_0%,#001843_100%)] xs:border-b border-white/20 relative overflow-hidden">
      <div className="w-full max-w-section mx-auto grid grid-cols-1 xs:grid-cols-2 gap-5 items-end">
        {/* Left */}
        <div className="relative h-147.5 xs:h-114 sm:h-139 lg:h-189 overflow-hidden">
          <video
            ref={videoRef}
            src="/next_assets/videos/mobile-strip.mp4"
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
            style={{
              maskImage: "radial-gradient(circle at center, black 40%, transparent 85%)",
              WebkitMaskImage: "radial-gradient(circle at center, black 40%, transparent 85%)",
            }}
          />
        </div>

        {/* Right */}
        <div className="absolute inset-x-0 top-6 xs:static text-center xs:text-left xs:self-center xs:py-8">
          <p className="text-2xl sm:text-2.5xl lg:text-[32px] leading-1.3! font-semibold mb-3 xs:mb-4">
            All-in-one Mutual Fund Investing app for everyone.
          </p>

          <p className="text-white/75 text-base sm:text-xl mb-5 xs:mb-8 lg:mb-12">Start your Investing Journey Today.</p>

          <div className="flex gap-6 items-center  justify-center sm:justify-start">
            <div className="flex sm:flex-col gap-2.5 xs:gap-6">
              {appStoreLinks.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label="Download app links"
                >
                  <Image
                    src={`/next_assets/images/common-images/${item.image}.png`}
                    alt={item.name}
                    width={250}
                    height={100}
                    className="w-35 h-11.25 md:w-150 md:h-half-px object-contain"
                  />
                </a>
              ))}
            </div>
            <Image
              src="/next_assets/images/strips/App-qr.png"
              alt="App QR Code"
              width={128}
              height={128}
              className="hidden sm:inline-block w-28 h-28 md:w-32 md:h-32"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
